import { render, staticRenderFns } from "./IntelligentBookingResultCommon.vue?vue&type=template&id=23b571bc&"
import script from "./IntelligentBookingResultCommon.vue?vue&type=script&lang=js&"
export * from "./IntelligentBookingResultCommon.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBookingResultCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b571bc')) {
      api.createRecord('23b571bc', component.options)
    } else {
      api.reload('23b571bc', component.options)
    }
    module.hot.accept("./IntelligentBookingResultCommon.vue?vue&type=template&id=23b571bc&", function () {
      api.rerender('23b571bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBookingResultCommon.vue"
export default component.exports